module.exports = __webpack_public_path__ + "static/media/Instagram.fbaa677c.png";